<script>
export default {
  props: ['uuid', 'action'],
  data() {
    return {
      title: 'Новый сценарий',
      name: '',
      description: '',
      user_phone: null,
      other: null,
      public: null,
      fl_ai: false
    }
  },

  async mounted () {
    const { uuid, action } = this
    if (action === 'create') return

    await this.$store.dispatch('skills/FETCH_SKILLS_ITEM', { uuid });
    const {name, description, access, fl_ai, ...other} = this.$store.getters['skills/GET_SKILLS_ITEM']
    
    this.name = name
    this.description = description
    this.other = other
    this.public = access === 'public' ? true : false
    this.fl_ai = fl_ai;
    this.title = 'Редактирование сценария'
  },

  methods: {
    async saveItem() {

      const dataSend = {
        name: this.name,
        description: this.description,
        version: 2,
        user_phone: this.user_phone,
        access: this.public === true ? 'public' : null,
        fl_ai: this.fl_ai ? 'true' : 'false',
        ...this.other
      };

      let result

      if (this.action === 'edite'){
        dataSend.uuid = this.uuid
        result = await this.$store.dispatch('skills/FETCH_SKILLS_UPDATE', dataSend)
      } else {
        result = await this.$store.dispatch('skills/FETCH_SKILLS_CREATE', dataSend)
      }

      if (!result) throw new Error('Возникла ошибка отправки данных')
      this.$emit('close')
    }
  }
}
</script>

<template>
  <b-form
      class="form-horizontal"
      @submit.prevent="saveItem"
  >
    <div class="row">
      <div class="col-12">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <b-form-group
                    label="Название сценария"
                    label-for="name"
                >
                  <b-form-input
                      id="name"
                      v-model="name"
                      placeholder="Укажите название"
                  />
                </b-form-group>

                <b-form-group
                    label="Комментарий к сценарию"
                    label-for="description"
                >
                  <b-form-input
                      id="description"
                      v-model="description"
                      placeholder=""
                  />

                  <b-form-group label="Передать на аккаунт пользователя" label-for="user_phone" style="margin-top: 15px">
                    <b-form-input id="user_phone" v-model="user_phone" placeholder="Укажите номер телефона или e-mail пользователя"/>
                  </b-form-group>                  

                  <b-form-checkbox v-model="fl_ai" name="fl_ai" style="margin-top: 5px; margin-bottom: 5px" switch>
                    Сценарий с ИИ
                  </b-form-checkbox>

                </b-form-group>
              </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-xl-12">
                    <b-form-checkbox v-model="public" name="public" style="margin-top: 5px; margin-bottom: 5px" switch>
                        Открыть публичный доступ к сценарию
                    </b-form-checkbox>
                </div>            
            </div>
          </div>
          <hr>
          <div class="btn-container" style="justify-content: flex-start; padding-left: 0px; padding-top: 25px">
            <button type="submit" class="btn btn-primary">Сохранить</button>
          </div>
        </div>
      </div>
  </b-form>
</template>

<style scoped>
.btn-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>